export var updateSubscription = function (input) {
    return {
        success: true
    };
};
